export function repairProposalCustomerSendState(input: {
  customerId: number;
  customerEmail?: string | null;
}): { canSend: boolean; customerHref: string; explanation: string | null } {
  const customerHref = `/sales/customers/${input.customerId}`;
  if (!String(input.customerEmail ?? "").trim()) {
    return {
      canSend: false,
      customerHref,
      explanation: "Add the customer's email address before sending this proposal.",
    };
  }
  return { canSend: true, customerHref, explanation: null };
}
